// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-btn {
  --button-color-primary-disabled: var(--white);
  --button-spinner-border-color-main: #f3f3f3;
  --button-spinner-border-color-section: #bdbdbd;
  border: none;
  background: none;
  outline: none;
  padding: 0;
  margin: 0;

  text-decoration: underline;
  text-underline-position: under;
}

.text-btn[disabled] {
  cursor: not-allowed;

  color: var(--button-color-primary-disabled);
  opacity: 0.34;
}

.text-btn .button-spinner {
  display: inline-block;
  border-width: 4px;
  border-style: solid;
  border-color: var(--button-spinner-border-color-main);
  border-top-color: var(--button-spinner-border-color-section);
  border-radius: 50%;
  -webkit-animation: buttonSpin 2s linear infinite;
  animation: buttonSpin 2s linear infinite;
  height: 18px;
  width: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.text-button.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,SAAS;;EAET,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;;EAEnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qDAAqD;EACrD,4DAA4D;EAC5D,kBAAkB;EAClB,gDAAgD;EAChD,wCAAwC;EACxC,YAAY;EACZ,WAAW;AACb","sourcesContent":[".text-btn {\n  --button-color-primary-disabled: var(--white);\n  --button-spinner-border-color-main: #f3f3f3;\n  --button-spinner-border-color-section: #bdbdbd;\n  border: none;\n  background: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n\n  text-decoration: underline;\n  text-underline-position: under;\n}\n\n.text-btn[disabled] {\n  cursor: not-allowed;\n\n  color: var(--button-color-primary-disabled);\n  opacity: 0.34;\n}\n\n.text-btn .button-spinner {\n  display: inline-block;\n  border-width: 4px;\n  border-style: solid;\n  border-color: var(--button-spinner-border-color-main);\n  border-top-color: var(--button-spinner-border-color-section);\n  border-radius: 50%;\n  -webkit-animation: buttonSpin 2s linear infinite;\n  animation: buttonSpin 2s linear infinite;\n  height: 18px;\n  width: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
